
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../dashboard/components/Navbar';
import BottomNav from '../dashboard/components/BottomNav';

export default function Profile() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState<'registered' | 'guest'>('registered');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    const type = localStorage.getItem('userType') as 'registered' | 'guest' || 'registered';
    setUserType(type);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userType');
    navigate('/login');
  };

  const profileData = {
    name: userType === 'guest' ? 'زائر' : 'محمد علي أحمد',
    email: userType === 'guest' ? 'guest@example.com' : 'mohammed.ali@email.com',
    phone: userType === 'guest' ? '+971 XX XXX XXXX' : '+971 50 123 4567',
    joinDate: userType === 'guest' ? 'اليوم' : '15 يناير 2023',
    totalTransfers: userType === 'guest' ? 0 : 342,
    totalAmount: userType === 'guest' ? 0 : 285600,
    verificationStatus: userType === 'guest' ? 'غير مؤكد' : 'مؤكد'
  };

  const menuItems = [
    {
      icon: 'ri-user-settings-line',
      title: 'إعدادات الحساب',
      subtitle: 'تحديث البيانات الشخصية',
      action: () => {},
      disabled: userType === 'guest'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'الأمان والخصوصية',
      subtitle: 'كلمة المرور والتحقق',
      action: () => {},
      disabled: userType === 'guest'
    },
    {
      icon: 'ri-notification-line',
      title: 'الإشعارات',
      subtitle: 'إدارة التنبيهات',
      action: () => {}
    },
    {
      icon: 'ri-customer-service-line',
      title: 'الدعم الفني',
      subtitle: 'تواصل معنا',
      action: () => {}
    },
    {
      icon: 'ri-file-text-line',
      title: 'الشروط والأحكام',
      subtitle: 'سياسة الاستخدام',
      action: () => {}
    },
    {
      icon: 'ri-information-line',
      title: 'حول التطبيق',
      subtitle: 'الإصدار 1.0.0',
      action: () => {}
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      <Navbar />
      
      <div className="pt-20 pb-20 px-4">
        <div className="max-w-md mx-auto">
          {/* معلومات المستخدم */}
          <div className="bg-white rounded-xl p-6 shadow-sm mb-6">
            <div className="text-center mb-6">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-3xl text-white"></i>
              </div>
              <h2 className="text-xl font-bold text-gray-800">{profileData.name}</h2>
              <p className="text-gray-600 text-sm">{profileData.email}</p>
              {userType === 'guest' && (
                <div className="mt-3">
                  <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                    حساب زائر
                  </span>
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4 text-center">
              <div className="bg-blue-50 rounded-lg p-3">
                <p className="text-2xl font-bold text-blue-600">{profileData.totalTransfers}</p>
                <p className="text-xs text-gray-600">إجمالي التحويلات</p>
              </div>
              <div className="bg-green-50 rounded-lg p-3">
                <p className="text-lg font-bold text-green-600">${profileData.totalAmount.toLocaleString()}</p>
                <p className="text-xs text-gray-600">إجمالي المبلغ</p>
              </div>
            </div>
          </div>

          {/* معلومات إضافية */}
          <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
            <h3 className="font-semibold text-gray-800 mb-4">معلومات الحساب</h3>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">رقم الهاتف:</span>
                <span className="font-medium">{profileData.phone}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">تاريخ الانضمام:</span>
                <span className="font-medium">{profileData.joinDate}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">حالة التحقق:</span>
                <span className={`font-medium ${
                  userType === 'guest' ? 'text-yellow-600' : 'text-green-600'
                }`}>
                  {profileData.verificationStatus}
                </span>
              </div>
            </div>
          </div>

          {/* رسالة للزائر */}
          {userType === 'guest' && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6">
              <div className="flex items-start">
                <i className="ri-information-line text-yellow-600 text-xl ml-3 mt-1"></i>
                <div>
                  <h4 className="font-medium text-yellow-800 mb-1">حساب زائر</h4>
                  <p className="text-sm text-yellow-700">
                    أنت تستخدم حساب زائر. بعض الميزات محدودة. قم بإنشاء حساب للحصول على جميع المميزات.
                  </p>
                  <button className="mt-2 text-sm font-medium text-yellow-800 hover:underline">
                    إنشاء حساب جديد
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* قائمة الإعدادات */}
          <div className="bg-white rounded-xl shadow-sm mb-6">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={item.action}
                disabled={item.disabled}
                className={`w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors ${
                  index !== menuItems.length - 1 ? 'border-b border-gray-100' : ''
                } ${
                  item.disabled ? 'opacity-50 cursor-not-allowed' : ''
                } ${
                  index === 0 ? 'rounded-t-xl' : ''
                } ${
                  index === menuItems.length - 1 ? 'rounded-b-xl' : ''
                }`}
              >
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center ml-3">
                    <i className={`${item.icon} text-gray-600`}></i>
                  </div>
                  <div className="text-right">
                    <h4 className="font-medium text-gray-800">{item.title}</h4>
                    <p className="text-sm text-gray-600">{item.subtitle}</p>
                  </div>
                </div>
                <i className="ri-arrow-left-s-line text-gray-400"></i>
              </button>
            ))}
          </div>

          {/* زر تسجيل الخروج */}
          <button
            onClick={() => setShowLogoutConfirm(true)}
            className="w-full bg-red-600 text-white py-3 rounded-xl font-medium hover:bg-red-700 transition-colors flex items-center justify-center"
          >
            <i className="ri-logout-box-line ml-2"></i>
            تسجيل الخروج
          </button>

          {/* نافذة تأكيد تسجيل الخروج */}
          {showLogoutConfirm && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-xl p-6 w-full max-w-sm">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-logout-box-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2">تسجيل الخروج</h3>
                  <p className="text-gray-600 text-sm">هل أنت متأكد من رغبتك في تسجيل الخروج؟</p>
                </div>
                
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowLogoutConfirm(false)}
                    className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300 transition-colors"
                  >
                    إلغاء
                  </button>
                  <button
                    onClick={handleLogout}
                    className="flex-1 bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 transition-colors"
                  >
                    تسجيل الخروج
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
